import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { URLSearchParams } from '@angular/http';

import { Api } from './api.service';
import { SimpleCrudInterface } from './crud.interface';
import { TrackerStatus } from '../entities/index';
import { Log } from '../utils/index';

@Injectable()
export class TrackerStatusService implements SimpleCrudInterface<TrackerStatus> {
  trackerStatus: Promise<TrackerStatus[]>;
  dataStore: TrackerStatus[] = [];

  constructor(protected http: Api) {}

  getAll(forceReload: boolean = false): Promise<TrackerStatus[]> {
    if (!this.trackerStatus || forceReload) {
      const params = new URLSearchParams();
      params.set('limit', '1000');
      params.set('sort_order', 'asc');
      params.set('sort_field', 'code');

      this.trackerStatus = this.http.get('tracker_status', { search: params }).toPromise().then(res => {
        return this.dataStore = res.items;
      });
    }

    return this.trackerStatus;
  }

  @Log('green')
  create(trackerStatus: TrackerStatus): Observable<TrackerStatus> {
    return this.http.post('tracker_status', trackerStatus);
  }

  @Log('green')
  update(trackerStatus: TrackerStatus): Observable<TrackerStatus> {
    const trackerStatusId = trackerStatus.id;
    return this.http.put(`tracker_status/${trackerStatusId}`, trackerStatus);
  }

  save(trackerStatus: TrackerStatus): Observable<TrackerStatus> {
    const isNew = undefined === trackerStatus.id;
    if (isNew) {
      return this.create(trackerStatus);
    } else {
      return this.update(trackerStatus);
    }
  }

  @Log('green')
  remove(trackerStatus: TrackerStatus): Observable<Response> {
    const trackerStatusId = trackerStatus.id;
    return this.http.delete(`tracker_status/${trackerStatusId}`);
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/trackerstatus.service.ts